"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logProgress = exports.logError = exports.logWarning = exports.logInfo = exports.clearLog = exports.setLogContext = void 0;
let logContext = null;
function setLogContext(div) {
    logContext = div;
}
exports.setLogContext = setLogContext;
function clearLog(context = logContext) {
    if (context) {
        context.innerHTML = "";
    }
}
exports.clearLog = clearLog;
function logInfo(msg) {
    if (logContext) {
        const info = document.createElement("p");
        info.className = "info";
        info.textContent = msg;
        logContext.appendChild(info);
    }
}
exports.logInfo = logInfo;
function logWarning(msg) {
    if (logContext) {
        const warning = document.createElement("p");
        warning.className = "warning";
        warning.textContent = msg;
        logContext.appendChild(warning);
    }
}
exports.logWarning = logWarning;
function logError(msg) {
    console.error(msg);
    if (logContext) {
        const error = document.createElement("p");
        error.className = "error";
        error.textContent = msg;
        logContext.appendChild(error);
    }
}
exports.logError = logError;
function logProgress(done, total) {
    var _a;
    if (logContext) {
        let progressBar = null;
        if (((_a = logContext === null || logContext === void 0 ? void 0 : logContext.lastElementChild) === null || _a === void 0 ? void 0 : _a.tagName.toLowerCase()) == "progress") {
            progressBar = logContext.lastElementChild;
        }
        if (!progressBar) {
            progressBar = document.createElement("progress");
            logContext.appendChild(progressBar);
        }
        progressBar.value = done;
        if (total !== undefined) {
            progressBar.max = total;
        }
    }
}
exports.logProgress = logProgress;
